/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import $ from 'jquery';
import { useIntl } from 'react-intl';
import { Typography, Box, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { hideModal, showModal } from 'state/actions';
import { MODAL, COLOR, SERVICEMODALSTEP, ENG } from 'config/constants';
import { useAuth, useListing, useLanguage, useAiServices } from 'hooks';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { HvModal, HvButton, HvBeforeAfterSlider } from 'components';
import { images } from 'assets/images';
import { VirtualServiceOrder } from 'models';
import { stagingImages } from './stepsConfig';
import PreviousOrders from './PreviousOrders';

const useStyles = makeStyles({
  modal: {
    width: '100%',
  },
  description: {
    fontSize: 14,
    marginBottom: 16,
  },
  smallCancelButton: {
    backgroundColor: 'white',
    marginRight: 10,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
    '@media (max-width: 768px)': {
      fontSize: 11,
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
    '@media (max-width: 768px)': {
      marginRight: 10,
    },
  },
  createNewButton: {
    '@media (max-width: 768px)': {
      fontSize: 11,
    },
  },
  nextButton: {
    '&:hover': {
      background: COLOR.LIGHT_BLUE,
    },
  },
  image: {
    width: '50%',
  },
  slider: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightArrow: {
    position: 'absolute',
    top: '50%',
    right: '32px',
    fontSize: 5,
    fill: 'white',
    zIndex: 10,
    cursor: 'pointer',
    userSelect: 'none',
    '@media (max-width: 768px)': {
      top: '40%',
      width: 25,
    },
  },
  leftArrow: {
    position: 'absolute',
    top: '50%',
    left: '32px',
    fontSize: 10,
    fill: 'white',
    zIndex: 10,
    cursor: 'pointer',
    userSelect: 'none',
    '@media (max-width: 768px)': {
      top: '40%',
      width: 25,
    },
  },
  slide: {
    opacity: 0,
    transitionDuration: '1s ease',
    flexDirection: 'row',
    margin: 20,
  },
  activeSlide: {
    opacity: 1,
    transitionDuration: '1s',
    transform: 'scale(1.08)',
    flexDirection: 'row',
    margin: 20,
  },
  divider: {
    backgroundColor: 'black',
    marginTop: 5,
    marginBottom: 5,
  },
  priceList: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    padding: 10,
    alignItems: 'center',
    backgroundColor: COLOR.ULTRA_LIGHT_GREY,
    borderRadius: 8,
  },
  title: {
    fontSize: 16,
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 'bold',
    '@media (max-width: 500px)': {
      fontSize: 12,
    },
  },
  priceText: {
    fontSize: 13,
    '@media (max-width: 500px)': {
      fontSize: 11,
    },
  },
  warning: {
    color: 'red',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
  },
  link: {
    display: 'inline',
    color: COLOR.LIGHT_BLUE,
    textDecoration: 'underline',
  },
  tag: {
    backgroundColor: COLOR.LIGHT_BLUE,
    color: 'white',
    padding: '2px 5px',
    borderRadius: 4,
    marginLeft: 10,
    fontSize: 11,
    animation: 'pulse-blue 2s infinite',
    '@media (max-width: 768px)': {
      marginLeft: 0,
      display: 'inline-block',
    },
  },
  promotion: {
    backgroundColor: COLOR.GREEN,
    color: 'white',
    padding: '2px 5px',
    borderRadius: 4,
    marginLeft: 10,
    fontSize: 11,
    animation: 'pulse-green 2s infinite',
    '@media (max-width: 768px)': {
      marginTop: 2,
      marginLeft: 0,
    },
  },
  alignRight: {
    textAlign: 'right',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  tagsContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      display: 'inline-block',
      flexDirection: 'column',
    },
  },
  crossedText: {
    textDecoration: 'line-through',
    textDecorationColor: COLOR.RED,
    color: COLOR.DARK_GREY,
    fontSize: 13,
    '@media (max-width: 500px)': {
      fontSize: 11,
    },
  },
  twoColsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  promoText: {
    color: COLOR.GREEN,
    fontSize: 13,
    fontFamily: 'FordAntenna-Medium',
  },
});
interface Props {
  setActiveStep: (_: number) => void;
  setOrder: (virtualServiceOrder: VirtualServiceOrder) => void;
  setSelectedImages: (_: any) => void;
  selectedService: any;
  setSelectedService: (_: any) => void;
}
function VirtualServiceExample({
  setActiveStep,
  setOrder,
  setSelectedImages,
  selectedService,
  setSelectedService,
}: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const [current, setCurrent] = useState(0);
  const path = window.location.pathname;
  const arr = path.split('/');
  const listing_token = arr[arr.length - 1];
  const { listing, virtualServiceOrders } = useListing(listing_token);
  const { is_AI_promotion_applied, nextAiStagingOrderIsFree } = useAiServices();
  const { virtualServices } = listing;
  virtualServices.sort((a, b) => {
    if (a.is_ai_service && !b.is_ai_service) {
      return -1;
    }
    if (!a.is_ai_service && b.is_ai_service) {
      return 1;
    }
    return 0;
  });
  const isEnglish = language === ENG;

  const [displayPrevOrders, setDisplayPrevOrders] = useState(false);

  const fmtPleaseGoTo = intl.formatMessage({ id: 'deliver.video_slideshow.pleaseGoTo' });
  const fmtProfilePage = intl.formatMessage({ id: 'deliver.video_slideshow.profilePage' });
  const fmtChangeSubscription = intl.formatMessage({
    id: 'deliver.aiServices.changeSubscription',
  });
  const fmtNew = intl.formatMessage({ id: 'new' });
  const fmtPreviousOrders = intl.formatMessage({ id: 'deliver.photos.previousOrders' });
  const fmtCreateNewOrder = intl.formatMessage({
    id: 'deliver.photos.virtualServiceModal.createNewOrder',
  });
  const fmtClaimYourPromotion = intl.formatMessage({
    id: 'deliver.photos.virtualServiceModal.claimYourPromotion',
  });
  const fmtFree = intl.formatMessage({ id: 'shooting.create.labels.freeServiceOffer' });
  const fmtGetFifthForFree = intl.formatMessage({
    id: 'deliver.aiServices.getFifthForFree',
  });

  useEffect(() => {});
  const checkAndSetSize = (beforePicture: any, afterPicture: any) => {
    const modalWidth = $('#virtualServicesModal').eq(0).width();
    const bodyWidth = window.innerWidth;
    const normalizedWidth = Math.min(beforePicture.width, afterPicture.width);
    const normalizedHeight = Math.min(beforePicture.height, afterPicture.height);
    const aspectRatio = normalizedHeight / normalizedWidth;
    let width = bodyWidth > 1000 ? normalizedWidth : modalWidth;
    width = width <= 750 ? width : 550;
    const height = width * aspectRatio;
    return { width, height };
  };

  const onClose = () => {
    dispatch(hideModal(MODAL.VIRTUAL_STAGING));
  };

  const nextSlide = () => {
    setCurrent(current === stagingImages.length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? stagingImages.length - 1 : current - 1);
  };

  const onNext = () => {
    if (selectedService.is_ai_service) {
      dispatch(hideModal(MODAL.VIRTUAL_STAGING));
      dispatch(showModal({ type: MODAL.AI_SERVICES, data: { selectedService } }));
    } else {
      setActiveStep(SERVICEMODALSTEP.OPTION);
    }
  };
  const onChangeOption = (service) => {
    if (selectedService && selectedService.id !== service.id) {
      setOrder({
        id: null,
        listing_id: listing.id,
        virtualServiceOrderItems: [],
        user_id: user.id,
        created_at: new Date(),
        shooting_id: listing.validated_shooting_id,
        service_offer_id: service.id,
      });
      setSelectedImages([]);
    }
    setSelectedService(service);
  };
  const buttons = (
    <Box>
      <HvButton
        className={displayPrevOrders ? styles.smallCancelButton : styles.cancelButton}
        onClick={onClose}
      >
        {intl.formatMessage({ id: 'deliver.photos.cancel' })}
      </HvButton>
      {displayPrevOrders ? (
        <HvButton
          onClick={() => {
            return setDisplayPrevOrders(false);
          }}
          className={styles.createNewButton}
        >
          {fmtCreateNewOrder}
        </HvButton>
      ) : (
        <HvButton
          onClick={onNext}
          className={styles.nextButton}
          disabled={!virtualServices.length || !selectedService}
        >
          {intl.formatMessage({ id: 'deliver.photos.next' })}
        </HvButton>
      )}
    </Box>
  );
  const renderVirtualStagingExamples = () => {
    return (
      <Box className={styles.slider}>
        <img src={images.prev} className={styles.leftArrow} onClick={prevSlide} alt='back' />
        <img src={images.next} className={styles.rightArrow} onClick={nextSlide} alt='next' />
        {stagingImages.map((img, index) => {
          if (index === current) {
            return (
              <div key={index} className={index === current ? styles.activeSlide : styles.slide}>
                <img className={styles.image} src={img.before} alt='before staging' />
                <img className={styles.image} src={img.after} alt='after staging' />
              </div>
            );
          }
          return null;
        })}
      </Box>
    );
  };
  const renderVirtualExample = () => {
    if (selectedService.example.before_image_url && selectedService.example.after_image_url) {
      return (
        <Box className={styles.row}>
          <img
            className={styles.image}
            src={selectedService.example.before_image_url}
            alt='before effect'
          />
          <img
            className={styles.image}
            src={selectedService.example.after_image_url}
            alt='after effect'
          />
        </Box>
      );
    }
    if (selectedService.example.image_url) {
      return (
        <Box className={styles.row}>
          <img className={styles.image} src={selectedService.example.image_url} alt='example' />
        </Box>
      );
    }
    return null;
  };
  const renderVirtualServicesExample = () => {
    return (
      <Box className={styles.row}>
        <img className={styles.image} src={stagingImages[0].before} alt='virtual services' />
        <img className={styles.image} src={stagingImages[0].after} alt='virtual services' />
      </Box>
    );
  };
  const renderAIVirtualStagingExamples = () => {
    return (
      <div className={styles.row}>
        <HvBeforeAfterSlider
          afterImage={selectedService.example.after_image_url}
          beforeImage={selectedService.example.before_image_url}
          checkAndSetSize={checkAndSetSize}
        />
      </div>
    );
  };

  const renderExamplePhotos = () => {
    switch (selectedService?.display_name) {
      case 'Virtual AI Staging':
        return renderAIVirtualStagingExamples();
      case 'Virtual Staging':
        return renderVirtualStagingExamples();
      case 'Virtual Renovation':
        return renderVirtualExample();
      case 'Virtual Blue Hour':
        return renderVirtualExample();
      default:
        return renderVirtualServicesExample();
    }
  };

  const renderServiceOptions = () => {
    if (displayPrevOrders) {
      return <PreviousOrders setDisplayPrevOrders={setDisplayPrevOrders} />;
    }
    return (
      <div>
        <Typography className={styles.description}>
          {intl.formatMessage({ id: 'deliver.photos.virtualServiceModal.subtitle' })}
        </Typography>
        {renderExamplePhotos()}
        {virtualServices.map((s, index) => {
          return (
            <Box
              key={index}
              className={styles.priceList}
              onClick={() => {
                return onChangeOption(s);
              }}
            >
              <Box>
                <div className={styles.twoColsRow}>
                  <div>
                    <Typography className={styles.title}>
                      {isEnglish ? s.display_name : s.display_name_fr}
                    </Typography>
                    <div>
                      <Typography
                        className={
                          s.is_ai_service && (!is_AI_promotion_applied || nextAiStagingOrderIsFree)
                            ? styles.crossedText
                            : styles.priceText
                        }
                      >
                        {`$${s.price}`}
                        {intl.formatMessage({
                          id: 'deliver.photos.virtualServiceModal.pricePerPhoto',
                        })}
                      </Typography>
                      {s.is_ai_service && (!is_AI_promotion_applied || nextAiStagingOrderIsFree) ? (
                        <Typography className={styles.promoText}>{fmtFree}</Typography>
                      ) : null}
                      {s.is_ai_service && is_AI_promotion_applied && (
                        <Typography className={styles.promoText}>{fmtGetFifthForFree}</Typography>
                      )}
                    </div>
                  </div>
                  {s.is_ai_service && (
                    <div className={styles.tagsContent}>
                      <Typography className={styles.tag}>{fmtNew}</Typography>
                      {!is_AI_promotion_applied || nextAiStagingOrderIsFree ? (
                        <Typography className={styles.promotion}>
                          {fmtClaimYourPromotion}
                        </Typography>
                      ) : null}
                    </div>
                  )}
                </div>
              </Box>
              <Box>
                {s.id === selectedService?.id ? (
                  <CheckCircleIcon color='secondary' />
                ) : (
                  <RadioButtonUncheckedOutlinedIcon />
                )}
              </Box>
            </Box>
          );
        })}
        {virtualServiceOrders.length ? (
          <Link
            className={styles.alignRight}
            onClick={() => {
              return setDisplayPrevOrders(true);
            }}
          >
            <Typography>{fmtPreviousOrders}</Typography>
          </Link>
        ) : null}
      </div>
    );
  };

  return (
    <HvModal
      id='virtualServicesModal'
      title={intl.formatMessage({ id: 'deliver.photos.virtualServiceModal.title' })}
      buttons={buttons}
      maxWidth='sm'
      headerImage='virtualStagingBg'
      onClose={onClose}
      className={styles.modal}
    >
      <Box>
        {virtualServices.length ? (
          renderServiceOptions()
        ) : (
          <Typography className={styles.warning}>
            <span>{`${fmtPleaseGoTo} `}</span>
            <span>
              <a
                onClick={() => {
                  dispatch(hideModal(MODAL.VIRTUAL_STAGING));
                  window.open('/profile', '_blank');
                }}
              >
                <span className={styles.link}>{fmtProfilePage}</span>
              </a>
            </span>
            <span>{` ${fmtChangeSubscription}`}</span>
          </Typography>
        )}
      </Box>
    </HvModal>
  );
}
export default VirtualServiceExample;
